import React, {useEffect, useState} from 'react';
import '../../css/Login.css'
import '../../css/button.css'
import {useNavigate} from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import api from "../../utils/axios";


const LoginComp = () => {
    const {login} = useAuth();
    const navigate = useNavigate();
    const [ssh_username, setUsername] = useState("");
    const [ssh_password, setPassword] = useState("");
    const [group_id, setGroupId] = useState("");
    const [error, setError] = useState('');

    useEffect(() => {
        document.title = "login page";
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post("/auth/login", {
                ssh_username,
                ssh_password,
                group_id: Number(group_id),
            });
            login(res.data);
            sessionStorage.setItem("show_admin_alerts", "1");
            navigate("/admin");
        } catch (err) {
            setError(err.response?.data?.msg || "Login failed");
        }
    };


  return (
    <div style={{marginTop:"75px", marginBottom:'30px'}}>
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Username:
          &nbsp;
          <input
              id={"username"}
              name={'username'}
              autoFocus={true}
              type="text"
              value={ssh_username}
              autoComplete="username"
              onChange={(e) => setUsername(e.target.value)}
          /></label>
        </div>
        <div style={{marginTop:"20px"}}>
          <label>Password:
          &nbsp;
          <input
              id={"password"}
              name={'password'}
              type="password"
              value={ssh_password}
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
          />
          </label>
        </div>
        <div style={{marginTop:"20px"}}>
          <label>Group ID:
          &nbsp;
          <input
              id={"group_id"}
              name={'group_id'}
              type="text"
              value={group_id}
              autoComplete="current-password"
              onChange={(e) => setGroupId(e.target.value)}
          /></label>
        </div>
        <button className={'button'} style={{marginTop:"20px"}} type="submit">
            Login
      </button>
      {error && <p>{error}</p>}
      </form>
    </div>
  );
};

export default LoginComp;